import { camelCase, transform, isPlainObject } from "lodash"

export function camelizeKeys(obj) {
  if (Array.isArray(obj)) {
    return obj.map(v => camelizeKeys(v))
  } else if (isPlainObject(obj)) {
    return transform(
      obj,
      (result, value, key) => {
        result[camelCase(key)] = camelizeKeys(value)
      },
      {}
    )
  }
  return obj
}
